// ConstantsChemistryCalculator.js
export const chemistryCalculators = [
  {
    name: "Kalkulator Massa Molar",
    link: "/calculator/id/molar-mass-calculator/",
    description:
      "Kalkulator massa molar adalah alat yang digunakan untuk menghitung massa molar suatu senyawa kimia dengan memasukkan rumus kimianya.",
    showMain: true,
  },
  {
    name: "Kalkulator Massa Besi",
    link: "/calculator/id/iron-mass/",
    description:
      "Kalkulator massa besi menghitung massa potongan besi berdasarkan dimensi yang dimasukkan.",
    showMain: true,
  },
  {
    name: "Kalkulator Massa Air",
    link: "/calculator/id/water-mass/",
    description:
      "Kalkulator massa air menghitung massa air berdasarkan volume dan massa jenis air.",
    showMain: true,
  },
  {
    name: "Kalkulator Volume Gas",
    link: "/calculator/id/gasvolume/",
    description:
      "Kalkulator ini menghitung volume gas dengan mudah dan menunjukkan langkah-langkah yang diperlukan untuk menghitungnya",
    showMain: true,
  },
  {
    name: "Kalkulator Muatan Ion",
    link: "/calculator/id/ion-charge-calculator/",
    description:
      "Kalkulator ini menghitung muatan ion untuk unsur-unsur kimia dengan mudah dan menunjukkan langkah-langkah yang diperlukan untuk menghitungnya",
    showMain: true,
  },
  {
    name: "Kalkulator Titik Embun",
    link: "/calculator/id/dew-point-calculator/",
    description:
      "Hitung suhu di mana udara harus didinginkan untuk mencapai kejenuhan dan membentuk embun.",
    showMain: true,
  },
  {
    name: "Kalkulator Kelarutan",
    link: "/calculator/id/solubility-calculator/",
    description:
      "Gunakan Kalkulator Kelarutan untuk menghitung jumlah maksimum zat yang dapat dilarutkan dalam air. Ketahui perbedaan antara larutan jenuh dan tidak jenuh.",
  },
  {
    name: "Kalkulator Berat Molekul",
    link: "/calculator/id/molecular-weight-calculator/",
    description:
      "Gunakan Kalkulator Berat Molekul untuk menghitung berat molekul senyawa kimia apa pun dengan mudah. Masukkan unsur-unsur kimia yang menyusun senyawa untuk menghitung berat molekul secara akurat.",
  },
  {
    name: "Kalkulator Berat Logam",
    link: "/calculator/id/metal-weight/",
    description:
      "Gunakan Kalkulator Berat Logam untuk menghitung berat berbagai logam dengan mudah dan akurat. Masukkan dimensi dan massa jenis untuk mendapatkan berat yang diinginkan.",
      showMain: true,
  },
  {
    name: "Kalkulator Jumlah Mol",
    link: "/calculator/id/moles-calculator/",
    description:
      "Gunakan Kalkulator Jumlah Mol untuk menghitung jumlah mol zat kimia apa pun dengan mudah. Masukkan massa, konsentrasi, jumlah partikel, atau volume gas pada kondisi standar (STP) untuk mendapatkan hasil yang akurat.",
  },
  {
    name: "Kalkulator Molaritas",
    link: "/calculator/id/molarity/",
    description:
      "Gunakan Kalkulator Molaritas untuk menghitung konsentrasi larutan kimia dengan mudah. Masukkan jumlah mol dan volume larutan untuk mendapatkan konsentrasi molar yang akurat.",
  }, 
  {
    name: "Kalkulator Massa Jenis",
    link: "/calculator/id/density/",
    description:
      "Gunakan Kalkulator Massa Jenis untuk menghitung massa jenis berbagai zat dengan mudah. Masukkan massa dan volume untuk mendapatkan massa jenis yang akurat.",
  },
  {
    name: "Kalkulator Pengenceran Larutan",
    link: "/calculator/id/solution-dilution/",
    description:
      "Gunakan Kalkulator Pengenceran Larutan untuk menghitung konsentrasi larutan setelah pengenceran dengan mudah. Masukkan konsentrasi awal, volume larutan awal, dan volume larutan encer untuk mendapatkan konsentrasi baru yang akurat.",
  },
  {
    name: "Kalkulator Hukum Gas Ideal",
    link: "/calculator/id/ideal-gas-law/",
    description:
      "Gunakan Kalkulator Hukum Gas Ideal untuk menghitung salah satu variabel dalam persamaan PV = nRT dengan mudah. Masukkan tekanan, volume, jumlah mol, atau suhu untuk mendapatkan hasil yang akurat.",
  } ,
  {
    name: "Kalkulator Energi Bebas Gibbs",
    link: "/calculator/id/gibbs-free-energy/",
    description:
      "Gunakan Kalkulator Energi Bebas Gibbs untuk menghitung perubahan energi bebas Gibbs (ΔG) untuk reaksi kimia apa pun dengan mudah. Masukkan perubahan entalpi (ΔH), perubahan entropi (ΔS), dan suhu untuk mendapatkan hasil yang akurat.",
  },
  {
    name: "Kalkulator Titrasi",
    link: "/calculator/id/titration/",
    description:
      "Gunakan Kalkulator Titrasi untuk menghitung konsentrasi larutan yang tidak diketahui dengan mudah. Masukkan volume dan konsentrasi larutan yang diketahui, serta volume larutan yang tidak diketahui untuk mendapatkan konsentrasi baru yang akurat.",
  },
  {
    name: "Kalkulator Konstanta Kelarutan (Ksp)",
    link: "/calculator/id/ksp-calculator/",
    description:
      "Gunakan Kalkulator Konstanta Kelarutan (Ksp) untuk menghitung konstanta kelarutan senyawa ionik apa pun dengan mudah. Masukkan konsentrasi ion dalam larutan untuk mendapatkan Ksp yang akurat.",
  },
  {
    name: "Kalkulator pH Asam",
    link: "/calculator/id/ph-acid/",
    description:
      "Gunakan Kalkulator pH Asam untuk menghitung nilai pH larutan asam apa pun dengan mudah. Masukkan konsentrasi ion hidrogen (H+) atau konsentrasi asam untuk mendapatkan nilai pH yang akurat.",
  }
];
export default chemistryCalculators;